import { Pagination as BasePagination } from "../../Pagination";
import { useTableContext, useTablePropsContext } from "../context";

export const Pagination = (() => {
  const table = useTableContext();
  const tableProps = useTablePropsContext();

  if (!table || tableProps?.displayStrategy !== "pagination") {
    return null;
  }

  return (
    <BasePagination
      key="pagination"
      type={"cardDefault"}
      {...tableProps?.paginationProps}
      previousDisabled={!table.getCanPreviousPage()}
      nextDisabled={!table.getCanNextPage()}
      pageCount={table.getPageCount()}
      forcePage={table.getState().pagination.pageIndex}
      onPageChange={pageIndex => table.setPagination(old => ({ ...old, pageIndex }))}
    />
  );
});